<template>
  <div class="modal-overlay" @click.self="$emit('cerrar')">
    <div class="modal-registro">
      <button class="modal-close" @click="$emit('cerrar')">✕</button>

      <!-- Formulario -->
      <div v-if="!registrado">
        <h5 class="modal-titulo">Crear cuenta</h5>
        <p class="modal-desc">
          Para comprar una suscripción necesitas una cuenta activa en Quanty.
        </p>

        <div class="campo">
          <label class="campo-label">Nombre</label>
          <input
            v-model="form.nombre"
            type="text"
            class="campo-input"
            placeholder="Tu nombre completo"
            :disabled="cargando"
          />
        </div>

        <div class="campo">
          <label class="campo-label">Email</label>
          <input
            v-model="form.email"
            type="email"
            class="campo-input"
            placeholder="tu@email.com"
            :disabled="cargando"
          />
        </div>

        <div class="campo">
          <label class="campo-label">Contraseña</label>
          <input
            v-model="form.password"
            type="password"
            class="campo-input"
            placeholder="Mínimo 8 caracteres"
            :disabled="cargando"
          />
        </div>

        <div class="campo">
          <label class="campo-label">Confirmar contraseña</label>
          <input
            v-model="form.password_confirmation"
            type="password"
            class="campo-input"
            placeholder="Repite la contraseña"
            :disabled="cargando"
            @keyup.enter="registrar"
          />
        </div>

        <p v-if="error" class="modal-error">{{ error }}</p>

        <button class="btn-registrar" :disabled="cargando" @click="registrar">
          <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
          {{ cargando ? 'Creando cuenta…' : 'Crear cuenta' }}
        </button>

        <p class="modal-login-link">
          ¿Ya tienes cuenta?
          <span class="link-accion" @click="abrirLogin">Iniciar sesión</span>
        </p>
      </div>

      <!-- Confirmación de email enviado -->
      <div v-else class="email-enviado">
        <div class="enviado-icono">✉️</div>
        <h5 class="modal-titulo">Revisa tu correo</h5>
        <p class="modal-desc">
          Te enviamos un enlace de verificación a
          <strong>{{ form.email }}</strong>.
        </p>
        <p class="modal-desc">
          Haz clic en el enlace del correo para activar tu cuenta y poder acceder a la suscripción.
        </p>
        <button class="btn-cerrar-ok" @click="$emit('cerrar')">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalRegistroEmail",
  emits: ["cerrar"],

  data() {
    return {
      registrado: false,
      cargando: false,
      error: "",
      form: {
        nombre: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
    };
  },

  methods: {
    async registrar() {
      this.error = "";

      if (!this.form.nombre.trim()) { this.error = "El nombre es obligatorio."; return; }
      if (!this.form.email.trim())  { this.error = "El email es obligatorio."; return; }
      if (this.form.password.length < 8) { this.error = "La contraseña debe tener al menos 8 caracteres."; return; }
      if (this.form.password !== this.form.password_confirmation) {
        this.error = "Las contraseñas no coinciden."; return;
      }

      this.cargando = true;
      try {
        const resp = await this.$store.dispatch("auth/registroEmailSuscripcion", {
          nombre:               this.form.nombre,
          email:                this.form.email,
          password:             this.form.password,
          password_confirmation: this.form.password_confirmation,
        });

        if (resp?.res === "OK") {
          this.registrado = true;
        } else {
          this.error = resp?.mensaje || "Ocurrió un error. Intenta de nuevo.";
        }
      } catch (err) {
        const data = err?.response?.data;
        if (data?.errors) {
          if (data.errors.email) {
            this.error = this.$t('pronostico.registroInlineErrorEmailTaken');
          } else {
            const firstKey = Object.keys(data.errors)[0];
            this.error = data.errors[firstKey]?.[0] || "Error de validación.";
          }
        } else if (data?.message) {
          this.error = data.message;
        } else {
          this.error = "Ocurrió un error. Intenta de nuevo.";
        }
      } finally {
        this.cargando = false;
      }
    },

    abrirLogin() {
      this.$emit("cerrar");
      this.$store.commit("abrirLoginModal");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

.modal-registro {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 420px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  background: none;
  border: none;
  font-size: 1.1rem;
  color: var(--q-muted);
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
}
.modal-close:hover { color: var(--q-text); }

.modal-titulo {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--q-text);
  margin-bottom: 0.5rem;
}

.modal-desc {
  font-size: 0.88rem;
  color: var(--q-muted);
  margin-bottom: 1.25rem;
  line-height: 1.5;
}

.campo {
  margin-bottom: 1rem;
}

.campo-label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--q-text);
  margin-bottom: 4px;
}

.campo-input {
  width: 100%;
  height: 40px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 8px;
  padding: 0 12px;
  font-size: 0.88rem;
  color: var(--q-text);
  transition: border-color 0.15s;
}
.campo-input:focus {
  outline: none;
  border-color: var(--q-gold);
}
.campo-input:disabled { opacity: 0.6; }

.modal-error {
  font-size: 0.82rem;
  color: var(--q-red, #ef4444);
  margin-bottom: 0.75rem;
  padding: 8px 12px;
  background: rgba(239, 68, 68, 0.08);
  border-radius: 6px;
}

.btn-registrar {
  width: 100%;
  padding: 11px;
  background: var(--q-gold);
  color: var(--q-gold-on, #0e203d);
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.btn-registrar:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-registrar:hover:not(:disabled) { opacity: 0.88; }

.modal-login-link {
  text-align: center;
  font-size: 0.82rem;
  color: var(--q-muted);
  margin-top: 1rem;
  margin-bottom: 0;
}

.link-accion {
  color: var(--q-gold);
  cursor: pointer;
  font-weight: 600;
}
.link-accion:hover { text-decoration: underline; }

/* Email enviado */
.email-enviado {
  text-align: center;
  padding: 1rem 0;
}

.enviado-icono {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.btn-cerrar-ok {
  padding: 10px 28px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 8px;
  color: var(--q-text);
  font-size: 0.88rem;
  cursor: pointer;
  margin-top: 0.5rem;
}
.btn-cerrar-ok:hover { border-color: var(--q-gold); }
</style>
